import { QuotationTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1603. 見積タスクコメント削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const deleteQuotationTaskComment = (props: Props): Promise<QuotationTaskComment> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_comments/${props.id}`
  );
};

export const useDeleteQuotationTaskComment = () => {
  return useMutation({
    mutationFn: deleteQuotationTaskComment,
  });
};
